import { defineNuxtPlugin } from '#app'
import { plugin as VueTippy } from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
 
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueTippy, {
        directive: 'tippy',
        defaultProps: {
            appendTo: () => document.body,
            allowHTML: false,
            placement: 'bottom',
            theme: 'light-border',
            maxWidth: 200,
            inertia: true,
            delay: [100, 0],
        },
    })
})
